// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import http from './http'
import http2 from './http/index_new'
import store from './store'
import baseMixin from './mixins/base'
import router from './router'
import cookie from 'vue-cookie'
// 创建本地cookie

// 全局引用vantui组件
import 'vant/lib/index.less'
import Vant, {Lazyload, Toast} from 'vant'

// 下拉触底
import infiniteScroll from 'vue-infinite-scroll'

// 弹窗
import swalAlert from './utils/swalAlert'

// 复制文本到粘贴板
import VueClipboards from 'vue-clipboards'

import SlideVerify from 'vue-monoplasty-slide-verify'

let invite_openid = (window.location.href.split('invite_openid=')[1] || '').split('&')[0].trim()
if (!window.localStorage.getItem('url')) {
  window.localStorage.setItem('url', window.location.href)
}
if (invite_openid) {
  window.localStorage.setItem('invite_openid', invite_openid)
}
Vue.prototype.$cookie = cookie

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Toast)
Vue.use(infiniteScroll)
Vue.prototype.swalAlert = swalAlert
Vue.use(VueClipboards)

Vue.prototype.$http = http
Vue.prototype.$http2 = http2

Vue.mixin(baseMixin)

Vue.config.productionTip = false
Vue.use(SlideVerify)

Vue.prototype.validSe = function (value, number = 255) {
  console.log(value)
  value = value.replace(/[`～*~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, '')
  if (value.length >= number) {
    this.$dialog.alert({
      title: '提示',
      message: '输入内容不能超过' + number + '个字符'
    })
  }
  return value
}

Vue.prototype.mobile = function (value) {
  if (value && (!(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/).test(value) || !(/^[1-9]\d*$/).test(value) || value.length !== 11)) {
    this.$dialog.alert({
      title: '提示',
      message: '手机号码不符合规范'
    })
  } else {
    return value
  }
}

// 只能输汉字
Vue.prototype.chineseOnly = function (value) {
  value = value.replace(/[^\u4E00-\u9FA5]/g, '')
  return value
}
// 只能输正整数
Vue.prototype.idOnly = function (value) {
  value = value.replace(/[^0-9]/g, '')
  return value
}
// 不允许输汉字
Vue.prototype.noChineseOnly = function (value) {
  value = value.replace(/[\u4E00-\u9FA5]/g, '')
  return value
}
// 逗号和数字
Vue.prototype.programIdOnly = function (value) {
  value = value.replace(/[^0-9,]/g, '')
  return value
}
// 数字和回车
Vue.prototype.idsOnly = function (value) {
  value = value.replace(/[^\r\n0-9]/g, '')
  return value
}
// 数值大小限定
Vue.prototype.numberLimit = function (value) {
  value = value.replace(/[^0-9]/g, '')
  if (value >= 2147483647) {
    this.$message({
      type: 'warning',
      message: `最大可输入值为2147483647`
    })
  }
  return value
}
// 正整数
Vue.prototype.onlyPositiveInteger = function (value) {
  value = String(value).match(/[1-9]\d*/g, '')
  return value === null ? '' : Number(value[0])
}
// 正整数（包含0）
Vue.prototype.onlyPositiveInteger1 = function (value) {
  value = String(value).match(/[1-9]\d*|0/g, '')
  return value === null ? '' : Number(value[0])
}
// 负整数
Vue.prototype.onlyNegativeInteger = function (value) {
  value = String(value).match(/^-[1-9]*\d*/g, '')
  return value === null ? '' : value[0] === '-' ? '-' : value[0] === '-0' ? '' : Number(value[0])
}
// 负整数（包含0）
Vue.prototype.onlyNegativeInteger1 = function (value) {
  value = String(value).match(/^-[1-9]*\d*|0/g, '')
  return value === null ? '' : value[0] === '-' ? '-' : Number(value[0])
}
// 整数
Vue.prototype.onlyInteger = function (value) {
  value = String(value).match(/^-?[1-9]*\d*|0/g, '')
  return value === null ? '' : value[0] === '-' ? '-' : value[0] === '' ? '' : Number(value[0])
}
// 整数区间
Vue.prototype.onlySection = function (value, min, max) {
  if (min < 0) {
    value = String(value).match(/-?[1-9]*\d*/g, '')
  } else {
    value = String(value).match(/[1-9]*\d*/g, '')
  }
  // value = String(value).match(/-?[1-9]*\d*/g, "")
  value = value === null ? '' : value[0] === '-' ? '-' : value[0] === '' ? '' : Number(value[0])
  if (value < min) {
    return min
  } else if (value > max) {
    return max
  } else {
    return value
  }
}

router.beforeEach((to, from, next) => {
  // 在这里进行你需要的任何初始化操作

  // 确保调用 next() 来resolve这个钩子
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js